"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ShadeInfo = require("./ShadeInfo");
Object.keys(_ShadeInfo).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ShadeInfo[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ShadeInfo[key];
    }
  });
});
